import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
} from "reactstrap"
import { SuccessOk } from "configs/statusCode"
import CardItem from "./CardItem"
import "./Style.scss"
import Paginator from "components/Common/Paginator/Paginator"
import SalesRepsService from "services/Admin/SalesRepsService"
import ModalForm from "./ModalForm"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import SuccessModal from "components/SucessModal"
import { adminPrefix } from "configs/routePrefix";
import { useSelector } from "react-redux"

const SalesRepPage = (props) => {
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const [modal, setModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [filterModal, setFilterModal] = useState(false)
    const [filterData, setFilterData] = useState({
        area_ids: null,
        compound_ids: null,
        country_ids: null
    })
    const [area, setArea] = useState([])
    const salesRepsService = new SalesRepsService()
    const [active, setActive] = useState("all");
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const [filtersParams, setFilterParams] = useState(null)
    const [shouldGetData, setShouldGetData] = useState(false)
    const [list, setList] = useState([])
    const [searchWord, setSearchWord] = useState("")
    const [exportUrl, setExportUrl] = useState("")
    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })


    const toggleModal = () => {
        setModal(!modal)
    }

    const [editObj, setEditObj] = useState(null)
    const [add, setAdd] = useState(true)

    const addHandler = () => {
        props.history.push(`${adminPrefix}/sales-rep/invite-sales-rep`)
        setAdd(true)
        setEditObj(null)
        toggleModal()
    }
    const updateHandler = (item) => {
        setEditObj(item)
        setAdd(false)
        toggleModal()


        props.history.push(`${adminPrefix}/sales-rep/update/${item.id}`)
    }



    useEffect(() => {
        // debounce solution to reduce request data from api
        const timeoutId = setTimeout(() => {
            const params = {}
            if (active != 'all') params['status'] = active === "active" ? 1 : 0
            if (searchWord.trim().length) params['keyword'] = searchWord
            if (filterData ?.area_ids ?.length !== 0) params["area_ids"] = filterData ?.area_ids ?.map(area => area.value).join()
            if (filterData ?.compound_ids ?.length !== 0) params["compound_ids"] = filterData ?.compound_ids ?.map(compound => compound.value).join()
            if (!!filterData ?.country_ids) params["country"] = filterData ?.country_ids?.value
    
            setFilterParams({ ...params })
        }, 1000)

        return () => clearTimeout(timeoutId)
    }, [searchWord, filterData, filterData, active])


    useEffect(() => {
        const url = salesRepsService.getExportUrl(searchWord, filterData, active)
        setExportUrl(url)
    }, [searchWord, filterData ?.area_ids , filterData ?.compound_ids, active])


    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)
    }



    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Sales Reps</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <h4>Manage Sales Rep</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by sales rep name, I.D"
                                    onChange={(e) => OnSearchChange(e)}
                                    value={searchWord}
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="d-flex justify-content-md-end removebtnhover">
                                <button
                                    className="btn btnUpload btnHeight btnHeight px-lg-4 me-2"
                                    disabled={loading ? true : false}
                                    onClick={() => window.open(exportUrl)}
                                >
                                    Export Excel Sheet
                                 </button>

                                {isExist("salesRep.add") ? <button
                                    className="btn btn-success btnHeight px-lg-4"
                                    onClick={addHandler}
                                >
                                    Invite Sales Rep
                                </button> : null}
                            </div>
                        </Col>
                    </Row>
                    <Row className="my-4 d-flex justify-content-between" >
                        <Col md={6} sm={8} className="mb-3">
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "all" ? "#556ee6" : "#f4f4f4",
                                    color: active == "all" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("all");
                                }}
                            >
                                All
                </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "active" ? "#556ee6" : "#f4f4f4",
                                    color: active == "active" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("active");
                                }}
                            >
                                Active
                </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                                    color: active == "deactive" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("deactive");
                                }}
                            >
                                Deactive
                </button>
                        </Col>
                        <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">

                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setFilterModal(true)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>

                    </Row>
                    <div>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <div className="py-3">
                                    <div>
                                        <div className="table-responsive">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-16">
                                                        I.D
                                                        </th>
                                                        <th className="font-size-16">
                                                            Name
                                                        </th>
                                                        <th className="font-size-16">
                                                            Email
                                                        </th>
                                                        <th className="font-size-16">
                                                            Num of leads
                                                        </th>
                                                        <th className="font-size-16">
                                                            Assigned Compounds
                                                        </th>
                                                        <th className="font-size-16">
                                                            Assigned Location
                                                        </th>
                                                        <th className="font-size-14">
                                                            status
                                                        </th>
                                                        <th className="font-size-16">
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.map(
                                                        (item, index) => (
                                                            <CardItem
                                                                key={index}
                                                                index={index}
                                                                {...item}
                                                                item={item}
                                                                Service={SalesRepsService}
                                                                updateHandler={updateHandler}
                                                                setShouldGetData={setShouldGetData}
                                                                history={props.history}

                                                            />
                                                        )
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        {filterModal ? <FilterModal
                            filters={filterData}
                            setFilters={setFilterData}
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                        /> : null}
                    </div>
                    {modal && (
                        <ModalForm
                            modal={modal}
                            toggle={toggleModal}
                            isAdd={add}
                            editObj={editObj}
                            setList={setList}
                            type="Area"
                            setShouldGetData={setShouldGetData}
                            setShowSuccessModal={setShowSuccessModal}

                        />
                    )}

                    <Row className="d-flex justify-content-end">
                        <Col className="d-flex justify-content-between" md={12} sm={12}>
                            <Paginator
                                service={salesRepsService}
                                pageOptions={pageOptions}
                                setData={(data) => setList([...data])}
                                setPageOptions={setPageOptions}
                                filtersParams={filtersParams}
                                shouldGetData={shouldGetData}
                                setShouldGetData={setShouldGetData}
                            />
                        </Col>
                    </Row>
                    {showSuccessModal && <SuccessModal
                        modal={showSuccessModal}
                        title={"Add Sales Rep"}
                        subtitle={"Admin can invite sales rep"}
                        message={"The invitation  sent successfully "}
                        onClick={() => {
                            setShowSuccessModal(false)
                        }} />}
                </Container>
            </div>
        </React.Fragment>
    )
}

export default SalesRepPage
